const Años =
({
    checking,
    setChecking,
    añosDisponibles,
    setAñosDisponibles,
    checkboxesAños,
    setCheckboxesAños,
    años,
    sorting,
    loading,
    setPagination,
    status422
}) =>
{
    const handleChildCheckbox = (e) =>
    {
        setChecking(true);

        const checked = e.target.checked;
        const año = e.target.value;

        if (checked === true)
        {
            const años = [];

            for (let i = 0; i < añosDisponibles.length; i++)
            {
                años.push(añosDisponibles[i]);
            }

            años.push(año);

            setAñosDisponibles(años);
        }
        else
        {
            const años = añosDisponibles.filter(anio => anio !== año);

            setAñosDisponibles(años);
        }

        // 1. Tu lógica para actualizar el estado en React
        setCheckboxesAños(
        {
            ...checkboxesAños,
            [año]: checked
        });

        // 2. Enviar la acción a Google Tag Manager
        if (window.dataLayer)
        {
            window.dataLayer.push(
            {
                event: 'buscador_experto_pesqueria_checkbox_anio',
                buscador_experto_pesqueria_checkbox_anio: document.querySelector(`label[for="${e.target.id}"]`).textContent,
                checkbox_accion: checked ? 'marcado' : 'desmarcado',
            });
        }

        setPagination(1);
    }

    return (
        <div className="card border-0 mb-1">
            <div className="accordion" id="accordionPanelEspecie">
                <div className="accordion-item">
                    <h5 className="accordion-header"><button className="accordion-button p-2 collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#panelsAños" aria-expanded="true" aria-controls="panelsAños">Años:</button></h5>
                    <div id="panelsAños" className="accordion-collapse collapse">
                        <div className="accordion-body">

                            {
                                años.map((año, index) =>
                                (
                                    <div className="row" key={index}>
                                        <div className="col">
                                            <div className="form-check">
                                                <input
                                                    type="checkbox"
                                                    className="form-check-input border-dark-subtle"
                                                    id={`anio-${index}`}
                                                    name="anio"
                                                    value={año.ANIO}
                                                    onChange={handleChildCheckbox}
                                                    checked={Object.hasOwn(checkboxesAños, `${año.ANIO}`) ? checkboxesAños[`${año.ANIO}`] : false}
                                                    disabled={!status422 && (!loading || checking || sorting)}
                                                />
                                                <label className="form-check-label" htmlFor={`anio-${index}`}>{año.ANIO}</label>
                                            </div>
                                        </div>
                                    </div>
                                ))
                            }

                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default Años;
